import quickOrderApp from './QuickOrderApp'
export default quickOrderApp